import { ReactNode } from "react";
import useSalesReport, {
  SalesReportContext,
  UseSalesReportProps,
} from "./useSalesReport";

export interface SalesReportProviderProps extends UseSalesReportProps {
  children?: ReactNode;
}

const SalesReportProvider: React.FC<SalesReportProviderProps> = ({
  children,
  ...props
}) => {
  const context = useSalesReport(props);

  return (
    <SalesReportContext.Provider value={context}>
      {children}
    </SalesReportContext.Provider>
  );
};
export default SalesReportProvider;
